// extracted by mini-css-extract-plugin
export default {"createExtract":"createExtract--Dmwdv"};